// Result List Response
class MyleDSQEmployeeResponse {
    public FirstName: string;
    public LastName: string;
    public NUI: string;
    public LicenceNumber: string;
    public LicenceRoot: string;
}

export { MyleDSQEmployeeResponse };
